import { useFeatureFlag as useFeatureFlagPayments } from '@cloudbeds/feature-flag-manager-payments';

import { FeatureFlag } from './FeatureFlag';

/**
 * Hook to return the current state of the given LaunchDarkly feature flag.
 * Updates when the flag changes, if change occurs locally via an override.
 *
 * @param {FeatureFlag} flag The specific feature flag to check.
 */
export const useFeatureFlag = (flag: FeatureFlag) =>
  useFeatureFlagPayments(flag);
